import React from 'react';
import { useTranslate } from '@hooks';
import { affiliateSourceTypes } from '@constants';
import { camelCase } from 'lodash';
import { Input } from '@dotone/react-ui-core';

const AffiliateSourceTypeSelect = (props) => {
  const { t } = useTranslate('affiliate', 'sourceType');

  const options = Object.values(affiliateSourceTypes).map((value) => ({
    label: t(camelCase(value)),
    value,
  }));

  return <Input type="select" options={options} {...props} />;
};

export default AffiliateSourceTypeSelect;
